import { ApiHttpError } from '../errors.js';
import { DEFAULT_OVERRIDES } from './defaults.js';
export function extractErrorFields(error) {
    const isNetwork = isNetworkFetchError(error);
    const message = extractErrorMessage(error, isNetwork);
    const status = extractStatus(error);
    const code = extractCode(error);
    const isAuthError = extractIsAuthError(error, status);
    const category = isNetwork
        ? 'network'
        : classifyErrorCategory({
            message,
            status,
            isAuthError,
            name: errorNameFromUnknown(error),
        });
    return { message, status, code, isAuthError, category };
}
export function classifyErrorCategory(fields) {
    if (fields.isAuthError || fields.status === 401) {
        return 'auth';
    }
    if (fields.status !== undefined) {
        if (fields.status >= 500) {
            return 'server';
        }
        if (fields.status >= 400) {
            return 'client';
        }
    }
    if (fields.message && isNetworkErrorMessage(fields.message, fields.name)) {
        return 'network';
    }
    return 'unknown';
}
function extractErrorMessage(error, isNetwork = isNetworkFetchError(error)) {
    if (typeof error === 'string') {
        return error;
    }
    const err = error;
    if (isNetwork) {
        return DEFAULT_OVERRIDES.networkError ?? 'Network connection error';
    }
    if (err?.message) {
        return err.message;
    }
    if (err?.response?.data?.message) {
        return err.response.data.message;
    }
    if (err?.response?.data?.error) {
        return err.response.data.error;
    }
    if (err?.response?.statusText) {
        return err.response.statusText;
    }
    return DEFAULT_OVERRIDES.unknownError ?? 'An unknown error occurred';
}
function extractStatus(error) {
    const err = error;
    return err?.status ?? err?.response?.status;
}
function extractCode(error) {
    const err = error;
    return err?.code ?? err?.response?.data?.code;
}
function extractIsAuthError(error, status) {
    const err = error;
    if (err instanceof ApiHttpError) {
        return err.isAuthError;
    }
    if (err?.isAuthError !== undefined) {
        return err.isAuthError;
    }
    return status === 401 ? true : undefined;
}
function isNetworkFetchError(error) {
    const err = error;
    return err?.name === 'TypeError' && !!err.message?.includes('fetch');
}
function isNetworkErrorMessage(message, name) {
    return name === 'TypeError' && message.includes('fetch');
}
function errorNameFromUnknown(error) {
    return error?.name;
}
